import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

const loginHeaderStyle = {
  title: css`
    font-size: 17px;
    padding-top: 15px;
  `,
  img: css`
    width: auto;
    height: 29px;
  `,
  logoContainer: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
};

export const HeaderButton = styled(Button)`
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #fff !important;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 20px;
    height: 20px;
    padding: 0 4px 0 0;
  }
`;

export const HeaderLogoutButton = styled(HeaderButton)`
  color: #219ce6 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-weight: bold !important;
`;

export default loginHeaderStyle;
